<ng-container *ngIf="!!brandingData">
  <branding-block
    [title]="'Fonts and Colors'"
    [greyText]="brandingData.template.id === 'joi' ? 'DEFAULT SELECTED' : ((brandingData.template.name || 'Unnamed Fonts and Colors Template') | uppercase) + ' SELECTED'"
    [changeText]="!canEditAccount ? '+ CHANGE IN BRAND OPTIONS' : '+ CHANGE/ADD IN BRAND OPTIONS'"
    (change)="editBranding('template')"
  ><brand-template *ngIf="!!brandingData.template"
    [template]="brandingData.template"
    [selectedViewOnly]="true"
    [readOnly]="true"
    ></brand-template>
  </branding-block>

  <branding-block
    [title]="'Header'"
    [greyText]="!brandingData.header ? 'NONE SELECTED' : ((brandingData.header.name || 'Unnamed Header Image Set') | uppercase) + ' SELECTED'"
    [changeText]="!brandingData.header ? '+ ADD FROM BRAND OPTIONS' : !canEditAccount ? '+ CHANGE IN BRAND OPTIONS' : '+ CHANGE/ADD IN BRAND OPTIONS'"
    (change)="editBranding('header')"
  ><brand-image *ngIf="!!brandingData.header" [readOnly]="true" [template]="brandingData.header"></brand-image>
  </branding-block>

  <branding-block
    [title]="'Social links'"
    [greyText]="!brandingData.social ? 'NONE SELECTED' : ((brandingData.social.name || 'Unnamed Social Links Set') | uppercase) + ' SELECTED'"
    [changeText]="!brandingData.social ? '+ ADD FROM BRAND OPTIONS' : !canEditAccount ? '+ CHANGE IN BRAND OPTIONS' : '+ CHANGE/ADD IN BRAND OPTIONS'"
    (change)="editBranding('social')"
  >
    <social-links [socialLinks]="brandingData.social?.social"></social-links>
  </branding-block>

  <branding-block
    [title]="'Footer links'"
    [greyText]="!brandingData.footerLinks ? 'NONE SELECTED' : ((brandingData.footerLinks.name || 'Unnamed Footer Links Set') | uppercase) + ' SELECTED'"
    [changeText]="!brandingData.footerLinks ? '+ ADD FROM BRAND OPTIONS' : !canEditAccount ? '+ CHANGE IN BRAND OPTIONS' : '+ CHANGE/ADD IN BRAND OPTIONS'"
    (change)="editBranding('footerLinks')"
  >
    <footer-links *ngIf="!!brandingData?.footerLinks" [footerLinks]="brandingData.footerLinks"></footer-links>
  </branding-block>

  <branding-block
    [title]="'Footer'"
    [greyText]="!brandingData.footer ? 'NONE SELECTED' : ((brandingData.footer.name || 'Unnamed Footer Image Set') | uppercase) + ' SELECTED'"
    [changeText]="!brandingData.footer ? '+ ADD FROM BRAND OPTIONS' : !canEditAccount ? '+ CHANGE IN BRAND OPTIONS' : '+ CHANGE/ADD IN BRAND OPTIONS'"
    (change)="editBranding('footer')"
  ><brand-image *ngIf="!!brandingData.footer" [readOnly]="true" [template]="brandingData.footer"></brand-image>
  </branding-block>

</ng-container>
